import 'babel-polyfill';
import assembler from '@reduct/assembler';
import * as sevenOfferPageNodeTypesComponents from "sevenOfferPageNodeTypes";
import * as sevenOfferPageReviewsComponents from "sevenOfferPageReviews";
import * as figurComponents from './Components';

const app = assembler();
app.registerAll(figurComponents);
app.registerAll(sevenOfferPageNodeTypesComponents);
app.registerAll(sevenOfferPageReviewsComponents);

setTimeout(() => app.run(), 0);
document.addEventListener('Seven.B2Capsules.PageLoaded', app.run());

if (window.location.search) {
    $('a[href]').each(function () {
        if ($(this).attr('href').includes('https://')) {
            $(this).attr('href', $(this).attr('href') + window.location.search);
        }
    });
}

$('.hamburger').click(function () {
    $(this).toggleClass('is-active');
});

window.klarnaExpressButtonAsyncCallback = function () {
    Klarna.ExpressButton.on('user-authenticated', function (callbackData) {
        $('#checkout-loader').show();

        $('input[name="--seven_offerpage_checkout-content_checkout_form[order][customer][firstName]"]').val(callbackData.first_name);
        $('input[name="--seven_offerpage_checkout-content_checkout_form[order][customer][lastName]"]').val(callbackData.last_name);
        $('input[name="--seven_offerpage_checkout-content_checkout_form[order][customer][street]"]').val(callbackData.address.street_address);
        $('input[name="--seven_offerpage_checkout-content_checkout_form[order][customer][line2]"]').val(callbackData.address.street_address2);
        $('input[name="--seven_offerpage_checkout-content_checkout_form[order][customer][zipCode]"]').val(callbackData.address.postal_code);
        $('input[name="--seven_offerpage_checkout-content_checkout_form[order][customer][city]"]').val(callbackData.address.city);
        $('input[name="--seven_offerpage_checkout-content_checkout_form[order][customer][phoneNumber]"]').val(callbackData.phone.replace('+', '00'));
        $('input[name="--seven_offerpage_checkout-content_checkout_form[order][customer][email]"]').val(callbackData.email);
        $('#payment-klarnaCheckout').prop("checked", true);

        $('#checkout-form').submit();
    });
}
